import BaseService from "./base-service";
import {serialize} from "../helpers/request";

export default class CommandService extends BaseService {

    constructor() {
        super('commands');
    }

    getCommandTypes = (query) => {
        return this.__get(`commands/types?${serialize(Object.assign({_dc: new Date().getTime()}, query))}`);
    }

    send = (data) => {
        return this.__post(`commands/send`, data);
    }
}
